import { objectToEnum } from "@euroland/libs";

/**
 * @type {{
 *    adaptive: "adaptive",
 *    compact: "compact",
 *    perspective: "perspective",
 *    quadrata: "quadrata",
 *    victor: "victor",
 * }}
 */
export const TOOL_TEMPLATE = {
  adaptive: "adaptive",
  compact: "compact",
  perspective: "perspective",
  quadrata: "quadrata",
  victor: "victor",
};

export const TRADE_HISTORY_FIELD = objectToEnum(/** @type { const } */({
  time: "Time",
  volume: "Volume",
  price: "Price",
  buyer: "Buyer",
  seller: "Seller",
}));

export const TIME_FORMAT_DEFAULT = "HH:mm:ss";

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const SHORT_MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const SHORT_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const SHORT_DATE_FORMAT = "DD-MMMM-YYYY";
export const SHORT_DATE_MOBILE_FORMAT = "DD-MM-YYYY";
export const DATE_FORMAT_PARAM = "YYYY-MM-DD";
export const FORMAT_NUMBER = "#,##0.00";
export const POSITIVE_NUMBER_FORMAT = 'n';
export const POSITIVE_CHANGE_NUMBER_FORMAT = '+n';
export const DEFAULT_DECIMAL_DIGITS = 2;

export const DEFAULT_TICKER_REFRESH_SECONDS = 60;

export const TAB = {
  AMOUNT_INVESTED: 1,
  SHARES_PURCHASED: 2,
};

export const CHART_TAB = {
  SPLINE_CHART: "SPLINE_CHART",
  COLUMN_CHART: "COLUMN_CHART",
};

export const SERIES_COLUM_TYPE = {
  INCREASE: "INCREASE",
  DECREASE: "DECREASE",
  OFFSET: "OFFSET",
};

export const PRICE_STATUS = {
  UP: 1,
  DOWN: 2,
};

export const SERIES_LINE_CHART_TYPE = {
  VALUE: "value",
  TOTAL_RETURN: "totalReturn",
};

export const MARKET_STATUS = {
  OPEN: "Open",
  CLOSE: "Close",
};

export const MAX_LENGTH_NUMBER = 15;

export const KEY_BOARD = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ENTER: "Enter",
  SPACE: " ",
  ESCAPE: "Escape",
  END: "End",
  HOME: "Home",
};

export const CHART_PATTERN = {
  SOLID: "Solid",
  SHORT_DASH: "ShortDash",
  SHORT_DOT: "ShortDot",
  SHORT_DASH_DOT: "ShortDashDot",
  SHORT_DASH_DOT_DOT: "ShortDashDotDot",
  DOT: "Dot",
  DASH: "Dash",
  LONG_DASH: "LongDash",
  DASH_DOT: "DashDot",
  LONG_DASH_DOT: "LongDashDot",
  LONG_DASH_DOT_DOT: "LongDashDotDot",
};

export const SETTING_FORMAT = {
  LONG_DATE: "longDate",
  SHORT_DATE: "shortDate",
  FULL_DATE: "fullDate",
  FULL_DATE_TIME: "fullDateTime",
};
